import RequestUrls from '@Constants/RequestUrlsConstants';
import MessageBroker from '@Services/MessageBroker';

export const getAllRelatedSubstances = ({ substanceId, databaseId }) => {
  return MessageBroker.send(RequestUrls.allRelatedSubstances, { id: substanceId, databaseId });
};

export const getSubstancesById = ({ structureId, databaseId }) => {
  return MessageBroker.send(RequestUrls.viewSubstancesById, { id: structureId, databaseId });
};

export const getAllPreparations = ({ resultName, databaseId, hitSetKey }) => {
  return MessageBroker.send(RequestUrls.linkPreparations, { resultName, databaseId, hitSetKey });
};
